module.exports = __webpack_public_path__ + "img/9788992172202.ba1fd290.jpg";